import { useMemo, useState } from 'react';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';
import { scheduleSelectors } from 'features/schedule/redux';
import type { CurriculumReport } from 'services/api';

export const useTableHeader = () => {
  const difficultyDistribution = useAppSelector(scheduleSelectors.getDifficultyDistribution);
  const schedule = useAppSelector(scheduleSelectors.getSchedule);
  const hideDifficultyDistributionConflicts = useAppSelector(
    scheduleSelectors.getHideDifficultyDistributionConflicts,
  );
  const [selectedClass, setSelectedClass] = useState<CurriculumReport | null>(null);
  const [modalVisible, setModalVisible] = useState(false);

  const classesWithViolations = useMemo(
    () => difficultyDistribution?.curriculumReports.map((report) => report.educationalClass.id),
    [difficultyDistribution],
  );

  const handleShowModal = (classReport?: CurriculumReport) => {
    if (classReport) {
      setModalVisible(true);
      setSelectedClass(classReport);
    }
  };
  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedClass(null);
  };

  return {
    state: {
      schedule,
      classesWithViolations,
      modalVisible,
      selectedClass,
      difficultyDistribution,
      hideDifficultyDistributionConflicts,
    },
    methods: { handleShowModal, handleCloseModal },
  };
};
